// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__aLdjB","label":"Completed_label__mP7sz"};